export default "### Urheberrecht\n\n[Hier können Sie die Copyright-Vermerke für die Software einfügen...]\n"